/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <karolpawlak.giap@gmail.com>, January 2020
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import { PersonalDataContainer } from '../../containers';
import AttachmentsPanel from '../../components/AttachmentsPanel';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import { DecisionContainer } from '../../containers';
import _ from 'lodash';
import { PanelStyle } from '../../constants';
import Select from 'react-select';

import v from './validators';
import fetch from '../../core/fetch/fetch.server';
import loadingData from './loading';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
  type,
} = PanelStyle;

const functionOptions = [
  {
    label: 'mieszkaniowa',
    value: 'mieszkaniowa',
    state: 'function',
  },
  {
    label: 'usługowa',
    value: 'usługowa',
    state: 'function',
  },
  {
    label: 'przemysłowa',
    value: 'przemysłowa',
    state: 'function',
  },
  {
    label: 'liniowa',
    value: 'liniowa',
    state: 'function',
  },
  {
    label: 'zabudowa zagrodowa – gospodarstwo',
    value: 'zabudowa zagrodowa – gospodarstwo',
    state: 'function',
  },
  {
    label: 'rolne/hodowlane/ogrodnicze',
    value: 'rolne/hodowlane/ogrodnicze',
    state: 'function',
  },
  {
    label: 'inna',
    value: 'inna',
    state: 'function',
  },
];

const rangeOptions = [
  {
    label: 'budowa',
    value: 'budowa',
    state: 'range',
  },
  {
    label: 'rozbudowa',
    value: 'rozbudowa',
    state: 'range',
  },
  {
    label: 'przebudowa',
    value: 'przebudowa',
    state: 'range',
  },
  {
    label: 'zmiana sposobu użytkowania',
    value: 'zmiana sposobu użytkowania',
    state: 'range',
  },
  {
    label: 'zabudowa zagrodowa – gospodarstwo',
    value: 'zabudowa zagrodowa – gospodarstwo',
    state: 'range',
  },
  {
    label: 'inny',
    value: 'inny',
    state: 'range',
  },
];

const agentAddOptions = [
  {
    label: 'TAK',
    value: 'TAK',
    state: 'agentAdd',
  },
  {
    label: 'NIE',
    value: 'NIE',
    state: 'agentAdd',
  },
];

const roadAccessOptions = [
  {
    label: 'gminnej',
    value: 'gminnej',
    state: 'roadAccess',
  },
  {
    label: 'powiatowej',
    value: 'powiatowej',
    state: 'roadAccess',
  },
  {
    label: 'wojewódzkiej',
    value: 'wojewódzkiej',
    state: 'roadAccess',
  },
  {
    label: 'nie dotyczy',
    value: 'nie dotyczy',
    state: 'roadAccess',
  },
];

const roadAccessTypeOptions = [
  {
    label: 'istniejący bezpośredni zjazd z tej drogi',
    value: 'istniejący bezpośredni zjazd z tej drogi',
    state: 'roadAccessType',
  },
  {
    label: 'projektowany bezpośredni zjazd z tej drogi',
    value: 'projektowany bezpośredni zjazd z tej drogi',
    state: 'roadAccessType',
  },
  {
    label: 'drogę wewnętrzną',
    value: 'drogę wewnętrzną tj. działkę nr',
    state: 'roadAccessType',
  },
  {
    label: 'ustanowienie odpowiedniej służebności drogowej',
    value: 'ustanowienie odpowiedniej służebności drogowej na działce nr',
    state: 'roadAccessType',
  },
];

const characteristicsOptions = [
  {
    label: 'budynek mieszkalny',
    value: 'budynek mieszkalny',
    state: 'characteristics',
  },
  {
    label: 'budynek mieszkalny jednorodzinny wolnostojący',
    value: 'budynek mieszkalny jednorodzinny wolnostojący',
    state: 'characteristics',
  },
  {
    label: 'budynek mieszkalny w zabudowie bliźniaczej',
    value: 'budynek mieszkalny w zabudowie bliźniaczej',
    state: 'characteristics',
  },
  {
    label: 'budynek mieszkalny w zabudowie szeregowej',
    value: 'budynek mieszkalny w zabudowie szeregowej',
    state: 'characteristics',
  },
  {
    label: 'budynek mieszkalny wielorodzinny',
    value: 'budynek mieszkalny wielorodzinny',
    state: 'characteristics',
  },
  {
    label: 'budynek gospodarczy ',
    value: 'budynek gospodarczy ',
    state: 'characteristics',
  },
  {
    label: 'budynek garażowy',
    value: 'budynek garażowy',
    state: 'characteristics',
  },
  {
    label: 'droga wewnętrzna',
    value: 'droga wewnętrzna',
    state: 'characteristics',
  },
  {
    label: 'infrastruktura  techniczna',
    value: 'infrastruktura  techniczna',
    state: 'characteristics',
  },
  {
    label: 'budynek biurowy',
    value: 'budynek biurowy',
    state: 'characteristics',
  },
  {
    label: 'budynek magazynowy',
    value: 'budynek magazynowy',
    state: 'characteristics',
  },
  {
    label: 'budynek produkcyjny',
    value: 'budynek produkcyjny',
    state: 'characteristics',
  },
  {
    label: 'budynek usługowy',
    value: 'budynek usługowy',
    state: 'characteristics',
  },
  {
    label: 'sieć telekomunikacyjna ',
    value: 'sieć telekomunikacyjna ',
    state: 'characteristics',
  },
  {
    label: 'sklep',
    value: 'sklep',
    state: 'characteristics',
  },
  {
    label: 'inna',
    value: 'inna',
    state: 'characteristics',
  },
];

const waterOptions = [
  {
    label: 'własne ujęcie (studnia)',
    value: 'własne ujęcie (studnia)',
    state: 'water',
  },
  {
    label: 'istniejące przyłącze sieci wodociągowej',
    value: 'istniejące przyłącze sieci wodociągowej',
    state: 'water',
  },
  {
    label: 'budowa nowego przyłącza do istniejącej sieci wodociągowej',
    value: 'budowa nowego przyłącza do istniejącej sieci wodociągowej',
    state: 'water',
  },
  {
    label: 'budowa nowego przyłącza do projektowanej do budowy sieci wodociągowej',
    value: 'budowa nowego przyłącza do projektowanej do budowy sieci wodociągowej',
    state: 'water',
  },
  {
    label: 'nie dotyczy',
    value: 'nie dotyczy',
    state: 'water',
  },
];

const sewageAmountUnitOptions = [
  {
    label: 'm3/miesiąc',
    value: 'm3/miesiąc',
    state: 'sewageAmountUnit',
  },
  {
    label: 'm3/kwartał',
    value: 'm3/kwartał',
    state: 'sewageAmountUnit',
  },
  {
    label: 'm3/rok',
    value: 'm3/rok',
    state: 'sewageAmountUnit',
  },
];

const waterDemandUnitOptions = [
  {
    label: 'm3/miesiąc',
    value: 'm3/miesiąc',
    state: 'waterDemandUnit',
  },
  {
    label: 'm3/kwartał',
    value: 'm3/kwartał',
    state: 'waterDemandUnit',
  },
  {
    label: 'm3/rok',
    value: 'm3/rok',
    state: 'waterDemandUnit',
  },
];

const sewageOptions = [
  {
    label: 'do planowanego do budowy zbiornika szczelnego na działce',
    value: 'do planowanego do budowy zbiornika szczelnego na działce',
    state: 'sewage',
  },
  {
    label: 'do planowanej do budowy przydomowej oczyszczalni biologicznej',
    value: 'do planowanej do budowy przydomowej oczyszczalni biologicznej',
    state: 'sewage',
  },
  {
    label: 'istniejącym przyłączem do istniejącej sieci kanalizacyjnej',
    value: 'istniejącym przyłączem do istniejącej sieci kanalizacyjnej',
    state: 'sewage',
  },
  {
    label: 'budowa przyłącza do istniejącej sieci kanalizacyjnej',
    value: 'budowa przyłącza do istniejącej sieci kanalizacyjnej',
    state: 'sewage',
  },
  {
    label: 'budowa przyłącza do projektowanej sieci kanalizacyjnej',
    value: 'budowa przyłącza do projektowanej sieci kanalizacyjnej',
    state: 'sewage',
  },
  {
    label: 'nie dotyczy',
    value: 'nie dotyczy',
    state: 'sewage',
  },
];

const heatingOptions = [
  {
    label: 'węglowe',
    value: 'węglowe',
    state: 'heating',
  },
  {
    label: 'gaz ziemny',
    value: 'gaz ziemny',
    state: 'heating',
  },
  {
    label: 'elektryczne',
    value: 'elektryczne',
    state: 'heating',
  },
  {
    label: 'olej opałowy',
    value: 'olej opałowy',
    state: 'heating',
  },
  {
    label: 'inne',
    value: 'inne',
    state: 'heating',
  },
  {
    label: 'nie dotyczy',
    value: 'nie dotyczy',
    state: 'heating',
  },
];

const energyOptions = [
  {
    label: 'istniejące przyłącze do sieci elektroenergetycznej',
    value: 'istniejące przyłącze do sieci elektroenergetycznej',
    state: 'energy',
  },
  {
    label: 'budowa przyłącza do istniejącej sieci elektroenergetycznej',
    value: 'budowa przyłącza do istniejącej sieci elektroenergetycznej',
    state: 'energy',
  },
  {
    label: 'budowa przyłącza do projektowanej sieci elektroenergetycznej',
    value: 'budowa przyłącza do projektowanej sieci elektroenergetycznej',
    state: 'energy',
  },
  {
    label: 'nie dotyczy',
    value: 'nie dotyczy',
    state: 'energy',
  },
];

const gasOptions = [
  {
    label: 'istniejące przyłącze do sieci gazowej',
    value: 'istniejące przyłącze do sieci gazowej',
    state: 'gas',
  },
  {
    label: 'budowa przyłącza do istniejącej sieci gazowej',
    value: 'budowa przyłącza do istniejącej sieci gazowej',
    state: 'gas',
  },
  {
    label: 'budowa przyłącza do projektowanej sieci gazowej',
    value: 'budowa przyłącza do projektowanej sieci gazowej',
    state: 'gas',
  },
  {
    label: 'nie dotyczy',
    value: 'nie dotyczy',
    state: 'gas',
  },
];

const trashOptions = [
  {
    label: 'zadaszone osłony lub pomieszczenia ze ścianami pełnymi bądź ażurowymi',
    value: 'zadaszone osłony lub pomieszczenia ze ścianami pełnymi bądź ażurowymi',
    state: 'trash',
  },
  {
    label: 'wyodrębnione pomieszczenia w budynku',
    value: 'wyodrębnione pomieszczenia w budynku',
    state: 'trash',
  },
  {
    label: 'utwardzony plac do ustawiania kontenerów z zamykanymi otworami wrzutowymi',
    value: 'utwardzony plac do ustawiania kontenerów z zamykanymi otworami wrzutowymi',
    state: 'trash',
  },
  {
    label: 'nie dotyczy',
    value: 'nie dotyczy',
    state: 'trash',
  },
];

const rainwaterOptions = [
  {
    label: 'kanalizacja deszczowa na działce umożliwiająca odprowadzenie wód opadowych do gminnej sieci kanalizacji deszczowej lub ogólnospławnej',
    value: 'kanalizacja deszczowa na działce umożliwiająca odprowadzenie wód opadowych do gminnej sieci kanalizacji deszczowej lub ogólnospławnej',
    state: 'rainwater',
  },
  {
    label: 'na własny teren nieutwardzony, do dołów chłonnych lub do zbiorników retencyjnych',
    value: 'na własny teren nieutwardzony, do dołów chłonnych lub do zbiorników retencyjnych',
    state: 'rainwater',
  },
  {
    label: 'nie dotyczy',
    value: 'nie dotyczy',
    state: 'rainwater',
  },
];

const agentDict = {
  agentName: {
    label: 'Imię i nazwisko:',
    editable: true,
  },
  agentAddress: {
    label: 'Adres zamieszkania:',
    editable: true,
    type: 'textarea',
  },
  agentPostOffice: {
    label: 'Urząd Pocztowy:',
    editable: true,
  },
  agentPostalCode: {
    label: 'Kod pocztowy:',
    editable: true,
  },
  agentPhoneNumber: {
    label: 'Tel. kontaktowy:',
    editable: true,
  },
  agentMotionAddress: {
    label: 'Adres do korespondencji:',
    editable: true,
    type: 'textarea',
  },
};

const agentInfoDict = {
  agentAdd: {
    label: 'Pełnomocnik:',
    editable: true,
    type: 'Select',
    options: agentAddOptions,
  },
};


const InvestDescDict = {
  mapScale: {
    label: 'Skala załączonej kopii mapy zasadniczej/katastralnej:',
    editable: true,
  },
  function: {
    label: 'Funkcja inwestycji:',
    editable: true,
    type: 'Select',
    options: functionOptions,
  },
  range: {
    label: 'Zakres inwestycji:',
    editable: true,
    type: 'Select',
    options: rangeOptions,
  },
  characteristics: {
    label: 'Charakterystyka techniczno – użytkowa:',
    editable: true,
    type: 'Select',
    options: characteristicsOptions,
  },
};


class WydanieDecyzjiWZ extends React.Component {
  state = {
    info: {
      agentAdd: null,
      agentName: null,
      agentAddress: null,
      agentPostOffice: null,
      agentPostalCode: null,
      agentPhoneNumber: null,
      agentMotionAddress: null,
      investDesc: null,
      mapScale: null,
      function: null,
      otherFunction: null,
      range: null,
      otherRange: null,
      characteristics: null,
      otherCharacteristics: null,
      roadAccess: null,
      roadAccessParcelNr: null,
      roadAccessType: null,
      roadParcelNr: null,
      roadParcelOwner: null,

      water: null,
      waterDemandAmount: null,
      waterDemandUnit: null,

      sewage: null,
      sewageCapacity: null,
      sewageAmount: null,
      sewageAmountUnit: null,

      heating: null,
      otherHeating: null,

      energy: null,
      power: null,

      gas: null,
      gasCapacity: null,
      gasUnit: null,

      trash: null,
      rainwater: null,
      otherTechEquipment: null,
      landUse: null,
      environmentImpact: null,

    },
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    selectedParcels: [],
    attachments: null,
    loading: false,
  };

  validators = {
    agentAdd: [v.NotSelected],
    investDesc: [v.NotNull],
    mapScale: [v.NotNull],
    function: [v.NotSelected],
    range: [v.NotSelected],
    characteristics: [v.NotSelected],
    roadAccess: [v.NotSelected],
    water: [v.NotSelected],
    sewage: [v.NotSelected],
    heating: [v.NotSelected],
    energy: [v.NotSelected],
    gas: [v.NotSelected],
    trash: [v.NotSelected],
    rainwater: [v.NotSelected],
    landUse: [v.NotNull],
    environmentImpact: [v.NotNull],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        });
      });
  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  renderTextArea = (title, field) => (
    <div className="row mobile-row" style={rowStyle}>
      <div className={leftCol} />
      <div className={labelCol}>
        <label style={labelStyle}>{title}</label>
      </div>
      <div className={inputCol}>
        <textarea
          name={field}
          style={{
            width: '100%',
            borderColor:
              Object.keys(this.state.errors).indexOf(field) > -1 &&
                this.state.errors[field] !== null &&
                this.state.errors[field].length > 0
                ? 'red'
                : '#ccc',
          }}
          className="form-control"
          rows={5}
          value={this.state.info[field] ? this.state.info[field] : ''}
          onChange={e => this.onChange(e, 'info')}
        />
        {/* RENDER ERROS IN SPAN */}
        {Object.keys(this.state.errors).indexOf(field) > -1 &&
          this.state.errors[field] !== null &&
          this.state.errors[field].length > 0
          ? this.state.errors[field].map((val, index) => (
            <span key={index} style={errorSpanStyle}>
              {val}
            </span>
          ))
          : null}
      </div>
    </div>
    );

  renderInput = (title, field) => (
    <div className="row mobile-row" style={rowStyle}>
      <div className={leftCol} />
      <div className={labelCol}>
        <label style={labelStyle}>{title}</label>
      </div>
      <div className={inputCol}>
        <input
          name={field}
          style={{
            width: '100%',
            borderColor:
              Object.keys(this.state.errors).indexOf(field) > -1 &&
                this.state.errors[field] !== null &&
                this.state.errors[field].length > 0
                ? 'red'
                : '#ccc',
          }}
          className="form-control"
          rows={5}
          value={this.state.info[field] ? this.state.info[field] : ''}
          onChange={e => this.onChange(e, 'info')}
        />
        {/* RENDER ERROS IN SPAN */}
        {Object.keys(this.state.errors).indexOf(field) > -1 &&
          this.state.errors[field] !== null &&
          this.state.errors[field].length > 0
          ? this.state.errors[field].map((val, index) => (
            <span key={index} style={errorSpanStyle}>
              {val}
            </span>
          ))
          : null}
      </div>
    </div>
    );

  renderSelect = (title, field, options) => (
    <div className="row mobile-row" style={rowStyle}>
      <div className={leftCol} />
      <div className={labelCol}>
        <label style={labelStyle}>{title}</label>
      </div>
      <div className={inputCol}>
        <Select
          placeholder="Wybierz z listy..."
          name="option"
          value={this.state.info[field] ? this.state.info[field] : ''}
          options={options}
          clearable={false}
          onChange={e => this.onChangeSelect(e, 'info')}
          style={{
            borderColor:
            Object.keys(this.state.errors).indexOf(field) > -1 &&
              this.state.errors[field] !== null &&
              this.state.errors[field].length > 0
              ? 'red'
              : '#ccc',
          }}
          onBlur={event => event.preventDefault()}
          optionClassName="needsclick"
          blurInputOnSelect={false}
        />
        {/* RENDER ERROS IN SPAN */}
        {Object.keys(this.state.errors).indexOf(field) > -1 &&
          this.state.errors[field] !== null &&
          this.state.errors[field].length > 0
          ? this.state.errors[field].map((val, index) => (
            <span key={index} style={errorSpanStyle}>
              {val}
            </span>
          ))
          : null}
      </div>
    </div>
    );

  onChangeSelect = (e, group) => {
    const name = e.state;
    if (name === 'ownershipType' && e.value !== 'we władaniu') {
      this.setState(
        {
          [group]: {
            ...this.state[group],
            [name]: e.value,
            otherownershipType: null,
          },
        },
        () => this.validate(group, name),
      );
    }
    else {
      this.setState(
        {
          [group]: {
            ...this.state[group],
            [name]: e.value,
          },
        },
        () => this.validate(group, name),
      );
    }
  }

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      info: {
        agentAdd: 'TAK',
        agentName: 'Jan Kowalski',
        agentAddress: 'ul. Testowa 11',
        agentPostOffice: 'Warszawa',
        agentPostalCode: '02-011',
        agentPhoneNumber: '500501502',
        agentMotionAddress: 'Adres testowy',
        investDesc: 'Dane testowe',
        mapScale: '1:1000',
        function: 'mieszkaniowa',
        range: 'budowa',
        characteristics: 'budynek mieszkalny',
        roadAccess: 'gminnej',
        roadAccessParcelNr: '1/111',
        roadAccessType: 'istniejący bezpośredni zjazd z tej drogi',
        water: 'własne ujęcie (studnia)',
        sewage: 'do planowanego do budowy zbiornika szczelnego na działce',
        sewageCapacity: '1000',
        heating: 'elektryczne',
        energy: 'istniejące przyłącze do sieci elektroenergetycznej',
        power: '5',
        gas: 'istniejące przyłącze do sieci gazowej',
        gasCapacity: '1000',
        gasUnit: 'm3/miesiąc',
        trash: 'zadaszone osłony lub pomieszczenia ze ścianami pełnymi bądź ażurowymi',
        rainwater: 'na własny teren nieutwardzony, do dołów chłonnych lub do zbiorników retencyjnych',
        otherTechEquipment: 'Ine potrzeby',
        landUse: 'Zagospodarowanie testowe',
        environmentImpact: 'Wpływ testowy',
      },
    });
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      });
      return;
    }

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!this.state.attachments || this.state.attachments.length === 0) {
      this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
      return;
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!hasFieldErrors) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          dzialki: this.state.selectedParcels,
          selectedParcels: this.state.selectedParcels,
          info: this.state.info,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.setState({
            loading: false }, () =>
            this.redirectToSummary(resp.jobId));
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : null} />
        <GrayPanel
          title={'1. Adres'}
        >
          <div className="help-desc">
            W celu wybrania przedmiotowej działki lub działek ewidencyjnych należy wykorzystać jeden
            z dwóch dostępnych sposobów wyboru działki:<br />
            <ol>
              <li>
                {' '}
                Wybrać obręb ewidencyjny z rozwijalnej listy obrębów, a następnie wpisać numer
                działki. W celu dodania kolejnej działki należy powtórzyć czynność.
              </li>
              <li>
                Wskazać działkę w oknie mapy wykorzystując przycisk{' '}
                <samp>"Wskaż działki na mapie"</samp>. W celu wybrania kilku działek konieczne jest
                przytrzymanie na klawiaturze klawisza <kbd>CTRL</kbd>.
              </li>
            </ol>
            Wybór działek można usunąć pojedynczo lub usuwając wszystkie za pomocą przycisku{' '}
            <samp>"Odznacz wszystko"</samp>.
          </div>
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>
        <DecisionContainer
          title={'2. Pełnomocnik'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={agentInfoDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />
        {this.state.info.agentAdd === 'TAK' ?
          <DecisionContainer
            title={'Dane identyfikacyjne pełnomocnika'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentDict}
            onChange={e => this.onChange(e, 'info')}
          />
        : null}
        <GrayPanel
          title={'3. Dane identyfikacyjne inwestycji'}
        >
          {this.renderTextArea('Rodzaj obiektu lub przewidywany sposób użytkowania obiektu/terenu (np. budowa, przebudowa, rozbudowa lub nadbudowa budynku mieszkalnego/gospodarczego lub wjazdu na działkę itp):', 'investDesc')}
        </GrayPanel>
        <DecisionContainer
          title={'4. Charakterystyka inwestycji:'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={InvestDescDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        >
          {this.state.info.function === 'inna' ?
            this.renderTextArea('Inna funkcja inwestycji:', 'otherFunction')
            : null}
          {this.state.info.range === 'inny' ?
            this.renderTextArea('Inny zakres inwestycji:', 'otherRange')
            : null}
          {this.state.info.characteristics === 'inna' ?
            this.renderTextArea('Inna charakterystyka techniczno – użytkowa:', 'otherCharacteristics')
            : null}
        </DecisionContainer>
        <GrayPanel
          title={'5. Przewidywane uzbrojenie techniczne'}
        >
          <label style={labelStyle}>a) Dostęp do drogi publicznej</label>
          {this.renderSelect('Rodzaj drogi:', 'roadAccess', roadAccessOptions)}
          {this.state.info.roadAccess && this.state.info.roadAccess !== 'nie dotyczy' ?
          this.renderInput('Nr działki:', 'roadAccessParcelNr')
          : null}
          {this.state.info.roadAccess && this.state.info.roadAccess !== 'nie dotyczy' ?
          this.renderSelect('Sposób dostępu:', 'roadAccessType', roadAccessTypeOptions)
          : null}
          {this.state.info.roadAccessType === 'drogę wewnętrzną tj. działkę nr' || this.state.info.roadAccessType === 'ustanowienie odpowiedniej służebności drogowej na działce nr' ?
            this.renderInput('Nr działki:', 'roadParcelNr')
          : null}
          {this.state.info.roadAccessType === 'drogę wewnętrzną tj. działkę nr' || this.state.info.roadAccessType === 'ustanowienie odpowiedniej służebności drogowej na działce nr' ?
            this.renderTextArea('Właściciel działki:', 'roadParcelOwner')
          : null}

          <label style={labelStyle}>b) Woda</label>
          {this.renderSelect('Rodzaj dostępu:', 'water', waterOptions)}
          {this.state.info.water && this.state.info.water !== 'własne ujęcie (studnia)' && this.state.info.water !== 'nie dotyczy' ?
          this.renderInput('Przewidywane zapotrzebowanie:', 'waterDemandAmount')
          : null}
          {this.state.info.water && this.state.info.water !== 'własne ujęcie (studnia)' && this.state.info.water !== 'nie dotyczy' ?
          this.renderSelect('Jednostka miary:', 'waterDemandUnit', waterDemandUnitOptions)
          : null}

          <label style={labelStyle}>c) Sposób odprowadzania ścieków</label>
          {this.renderSelect('Wybierz sposób:', 'sewage', sewageOptions)}
          {this.state.info.sewage && this.state.info.sewage === 'do planowanego do budowy zbiornika szczelnego na działce' ?
          this.renderInput('Pojemność [m3]:', 'sewageCapacity')
          : null}
          {this.state.info.sewage && this.state.info.sewage === 'do planowanej do budowy przydomowej oczyszczalni biologicznej' ?
          this.renderInput('Przepustowość [m3/dobę]:', 'sewageCapacity')
          : null}
          {this.state.info.sewage && this.state.info.sewage !== 'do planowanego do budowy zbiornika szczelnego na działce' && this.state.info.sewage && this.state.info.sewage !== 'nie dotyczy' && this.state.info.sewage && this.state.info.sewage !== 'do planowanej do budowy przydomowej oczyszczalni biologicznej' ?
          this.renderInput('Przewidywana ilość ścieków:', 'sewageAmount')
          : null}
          {this.state.info.sewage && this.state.info.sewage !== 'do planowanego do budowy zbiornika szczelnego na działce' && this.state.info.sewage && this.state.info.sewage !== 'nie dotyczy' && this.state.info.sewage && this.state.info.sewage !== 'do planowanej do budowy przydomowej oczyszczalni biologicznej' ?
          this.renderSelect('Jednostka miary:', 'sewageAmountUnit', sewageAmountUnitOptions)
          : null}

          <label style={labelStyle}>d) Centralne ogrzewanie</label>
          {this.renderSelect('Wybierz rodzaj:', 'heating', heatingOptions)}
          {this.state.info.heating === 'inne' ?
            this.renderTextArea('Inny rodzaj:', 'otherHeating')
          : null}

          <label style={labelStyle}>e) Energia elektryczna</label>
          {this.renderSelect('Wybierz rodzaj:', 'energy', energyOptions)}
          {this.state.info.energy && this.state.info.energy !== 'nie dotyczy' ?
            this.renderInput('Moc [kW]:', 'power')
          : null}

          <label style={labelStyle}>f) Gaz</label>
          {this.renderSelect('Wybierz rodzaj:', 'gas', gasOptions)}
          {this.state.info.gas && this.state.info.gas !== 'nie dotyczy' ?
            this.renderInput('Przewidywane zapotrzebowanie:', 'gasCapacity')
          : null}
          {this.state.info.gas && this.state.info.gas !== 'nie dotyczy' ?
          this.renderSelect('Jednostka miary:', 'gasUnit', waterDemandUnitOptions)
          : null}

          <label style={labelStyle}>g) Miejsce gromadzenia odpadów stałych</label>
          {this.renderSelect('Wybierz rodzaj:', 'trash', trashOptions)}

          <label style={labelStyle}>h) Odprowadzanie wód opadowych</label>
          {this.renderSelect('Wybierz rodzaj:', 'rainwater', rainwaterOptions)}

          <label style={labelStyle}>i) inne potrzeby w zakresie infrastruktury technicznej</label>
          {this.renderTextArea('Inne potrzeby:', 'otherTechEquipment')}
        </GrayPanel>

        <GrayPanel
          title={'6. Planowany sposób zagospodarowania terenu, charakterystyka zabudowy, w tym przeznaczenie i gabaryty projektowanych obiektów budowlanych oraz powierzchni terenu podlegającej przekształceniu'}
        >
          <label style={labelStyle}>Opisać: rodzaj i ilość obiektów oraz ich przeznaczenie, pow. zabudowy w m2, charakterystyczne dane  obiektów (w przypadku budynków:  szerokość elewacji frontowej, liczba kondygnacji, wysokość do górnej krawędzi elewacji frontowej i do głównej kalenicy, rodzaj i pokrycie dachu, układ połaci dachowych, kierunek głównej kalenicy w stosunku do drogi;  w przypadku innych obiektów lub obiektów infrastruktury technicznej należy podać wszystkie dane techniczne). Należy także podać  wielkość powierzchni terenu (m2), która ma ulec przekształceniu w wyniku realizacji inwestycji. W razie braku miejsca na podanie niezbędnych danych należy do wniosku dołączyć opracowanie zawierające dokładny opis przedsięwzięcia</label>
          {this.renderTextArea('', 'landUse')}
        </GrayPanel>
        <GrayPanel
          title={'7. Wpływ inwestycji na środowisko'}
        >
          <label style={labelStyle}>Należy podać rodzaj i skalę przedsięwzięcia, rodzaj technologii, obszar na który inwestycja może oddziaływać, poziom hałasu lub innych uciążliwości powstających podczas funkcjonowania inwestycji po wybudowaniu, ilość oraz sposób unieszkodliwiania odpadów i zanieczyszczeń  mogących powstać podczas realizacji inwestycji oraz funkcjonowania obiektu po wybudowaniu ilość mas ziemi usuwanych lub  przemieszczanych podczas realizacji inwestycji oraz przewidywany sposób ich zagospodarowania, powierzchnie zabudowaną terenu obejmującą obiekty budowlane oraz pozostałą pow. przeznaczoną do przekształcenia w wyniku realizacji przedsięwzięcia)</label>
          {this.renderTextArea('', 'environmentImpact')}
        </GrayPanel>
        <GrayPanel
          title={'8. Informacje dla wnioskodawcy'}
        >
          <div className="row">
            <div className="col-sm-12">
              <p><b>Do niniejszego wniosku należy dołączyć załączniki:</b></p>
              <p>1. Kopia mapy zasadniczej/katastralnej z oznaczeniem granic terenu objętego wnioskiem i obszaru, na który ta inwestycja będzie oddziaływać (oznaczenia należy opisać w formie legendy)</p>
              <p>2. Koncepcja planowanego sposobu zagospodarowania terenu, przedstawiona w formie graficznej</p>
              <p>3. Gabaryty planowanych obiektów, przedstawione w formie graficznej</p>
              <p>4. Pełnomocnictwo (w przypadku działania przez pełnomocnika)</p>
              <p>5. Odpis aktualny z Rejestru Przedsiębiorców Krajowego Rejestru Sądowego (w przypadku wniosku składanego przez osobę prawną)</p>
              <p>6. Dowód zapłaty opłaty skarbowej (jeżeli wymagana)</p>
              <p>7. Decyzja o środowiskowych uwarunkowaniach (w przypadku gdy przedsięwzięcie wymaga uzyskania takiej decyzji zgodnie z przepisami odrębnymi).</p>
            </div>
          </div>
        </GrayPanel>

        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} />

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

WydanieDecyzjiWZ.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(WydanieDecyzjiWZ),
);



// WEBPACK FOOTER //
// src/routes/eservices/WydanieDecyzjiWZ.js